import { c as _c } from "react/compiler-runtime";
import { Popover } from '@base-ui/react/popover';
import type { DetailedHTMLProps, HTMLAttributes, MouseEventHandler } from 'react';
import { Card } from '@/components/Card';
import { CardActionTitleBar } from '@/components/CardActionTitleBar';
import { BackIcon } from '@/components/icons/BackIcon';
import { CloseIcon } from '@/components/icons/CloseIcon';
export interface HeroBlockSearchCardProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  onClose?: MouseEventHandler<HTMLButtonElement>;
  onBack?: MouseEventHandler<HTMLButtonElement>;
  showBack?: boolean;
  'data-testid'?: string;
}
export function HeroBlockSearchCard(t0) {
  const $ = _c(21);
  let children;
  let onBack;
  let onClose;
  let props;
  let showBack;
  let title;
  if ($[0] !== t0) {
    ({
      title,
      onClose,
      children,
      showBack,
      onBack,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = onBack;
    $[3] = onClose;
    $[4] = props;
    $[5] = showBack;
    $[6] = title;
  } else {
    children = $[1];
    onBack = $[2];
    onClose = $[3];
    props = $[4];
    showBack = $[5];
    title = $[6];
  }
  let t1;
  if ($[7] !== onBack || $[8] !== showBack) {
    t1 = showBack ? <button className="btn btn-circle [--btn-bg:transparent] [--border:0]" data-testid="search-form-back-button" onClick={onBack}><BackIcon className="text-2xl" /></button> : null;
    $[7] = onBack;
    $[8] = showBack;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CloseIcon className="text-2xl" />;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== onClose) {
    t3 = <Popover.Close className="btn btn-circle [--btn-bg:transparent] [--border:0]" data-testid="popover-close-button" onClick={onClose}>{t2}</Popover.Close>;
    $[11] = onClose;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t1 || $[14] !== t3 || $[15] !== title) {
    t4 = <CardActionTitleBar leftAction={t1} rightAction={t3}>{title}</CardActionTitleBar>;
    $[13] = t1;
    $[14] = t3;
    $[15] = title;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== children || $[18] !== props || $[19] !== t4) {
    t5 = <Card titleBar={t4} {...props}>{children}</Card>;
    $[17] = children;
    $[18] = props;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
}